module.exports = __webpack_public_path__ + "images/icon_log_small.svg?5320ebfe260016cc41a83e7ddc04f081";